import {
  IconDigitalBooks,
  IconDoorOpenFill,
  IconImportBookshelf,
  IconImportSeiseki,
  IconImportStudent,
  IconKarteFill,
  IconSectionUsageRate,
  IconTextbookFill,
} from "@studyplus/boron-ui";
import { MultiSectionBatchType } from "../../../interfaces/MultiSectionBatchesOperation";

type MultiSectionBatchInfo = {
  batchTypeHuman: string;
  dataTypeLabel: string;
  fileNamePrefix: string;
  Icon: React.FC<{ className: string }>;
};

export const getMultiSectionBatchInfo = (
  batchType: MultiSectionBatchType,
): MultiSectionBatchInfo => {
  switch (batchType) {
    case "download_study_records":
      return {
        batchTypeHuman: "学習記録のダウンロード",
        dataTypeLabel: "学習記録データ",
        fileNamePrefix: "学習記録",
        Icon: IconTextbookFill,
      };
    case "download_stays":
      return {
        batchTypeHuman: "入退室記録のダウンロード",
        dataTypeLabel: "入退室記録データ",
        fileNamePrefix: "入退室記録",
        Icon: IconDoorOpenFill,
      };
    case "download_kartes":
      return {
        batchTypeHuman: "面談記録のダウンロード",
        dataTypeLabel: "面談記録データ",
        fileNamePrefix: "面談記録",
        Icon: IconKarteFill,
      };
    case "download_students":
      return {
        batchTypeHuman: "生徒一覧のダウンロード",
        dataTypeLabel: "生徒一覧データ",
        fileNamePrefix: "生徒一覧",
        Icon: IconImportStudent,
      };
    case "download_examination_results":
      return {
        batchTypeHuman: "成績記録のダウンロード",
        dataTypeLabel: "成績記録データ",
        fileNamePrefix: "成績記録",
        Icon: IconImportSeiseki,
      };
    case "download_section_usage_rates":
      return {
        batchTypeHuman: "校舎別活用率のダウンロード",
        dataTypeLabel: "校舎別活用率データ",
        fileNamePrefix: "校舎別活用率",
        Icon: IconSectionUsageRate,
      };
    case "download_ai_question_details":
      return {
        batchTypeHuman: "AI質問詳細のダウンロード (β)",
        dataTypeLabel: "AI質問詳細データ",
        fileNamePrefix: "AI質問詳細",
        Icon: IconImportBookshelf,
      };
    case "download_ai_question_counts":
      return {
        batchTypeHuman: "AI質問回数のダウンロード (β)",
        dataTypeLabel: "AI質問回数データ",
        fileNamePrefix: "AI質問回数",
        Icon: IconImportBookshelf,
      };
    case "upload_drill":
      return {
        batchTypeHuman: "デジタル教材の登録",
        dataTypeLabel: "デジタル教材",
        fileNamePrefix: "デジタル教材",
        Icon: IconDigitalBooks,
      };
    case "update_drill":
      return {
        batchTypeHuman: "デジタル教材の更新",
        dataTypeLabel: "デジタル教材",
        fileNamePrefix: "デジタル教材",
        Icon: IconDigitalBooks,
      };
    default:
      throw "無効なバッチタイプです";
  }
};
